import type { Size } from "web_myplann/Chat/Types/pinchZoom";

export const getContainedSize = (
	container: Size,
	natural: Size | undefined,
): Size => {
	if (!natural || natural.width <= 0 || natural.height <= 0) {
		return { width: container.width, height: container.height };
	}

	const fit = Math.min(
		container.width / natural.width,
		container.height / natural.height,
	);

	return { width: natural.width * fit, height: natural.height * fit };
};
